import { ArrowUpRight, MapPin } from "lucide-react";
import { Reveal, ScrollHeading, Eyebrow, ActionLink } from "./ui";
export function Contact() {
  return (
    <section className="contact" id="contact">
      <div className="wrap">
        <Reveal className="contact-top">
          <Eyebrow number="07">Start a conversation</Eyebrow>
        </Reveal>
        <Reveal>
          <ScrollHeading
            lines={[
              { text: "Tell us what", muted: false },
              { text: "you're building.", muted: true },
            ]}
          />
        </Reveal>
        <Reveal className="contact-bottom">
          <p>
            Share your idea, the challenge you're facing, or the software you
            want to improve. We'll discuss your goals and the next steps for
            your project.
          </p>
          <ActionLink
            href="mailto:quantumcodecorp@gmail.com"
            className="primary-button"
          >
            Email us
          </ActionLink>
        </Reveal>
        <div className="contact-details">
          <a href="mailto:quantumcodecorp@gmail.com">
            quantumcodecorp@gmail.com
            <ArrowUpRight size={17} />
          </a>
          <span>
            <MapPin size={15} />
            Toronto, Ontario
          </span>
        </div>
      </div>
    </section>
  );
}
